import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad49a598"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "lg:grid lg:grid-rows-2 lg:grid-cols-2 lg:gap-x-20" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosticSection',
  props: {
  id: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: __props.id,
    class: "container item mx-auto px-6 sm:px-20 xl:px-40 py-8 2xl:py-10 text-base"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})